/** @jsxImportSource @emotion/react */
import dayjs from "dayjs";
import Field, { DataSource } from "./Field";

/**
 * LayerFruitAgeField - Calculates fruit age on the fly using the same logic as the Python backend
 *
 * This field implements the same calculation logic as calculate_fruit_age.py:
 * 1. Prioritizes harvest_date over packing_date for origin date
 * 2. Prioritizes arrival_date_intake over intake_check_created for arrival date
 * 3. Calculates days from origin date to current date
 * 4. Returns null if either date is missing or invalid
 */
class LayerFruitAgeField extends Field {
    field_type = "layer_fruit_age_field";


    backend_table = "layer_meta";

    get_backend_fieldname(): string[] {
        return [`${this.backend_table}.harvest_date`, `${this.backend_table}.packing_date`];
    }

    fruit_age: any | null = null;


    // * set the value from one of the the objects
    set_value(datasource: DataSource): this {
        this.value = null;

        // Get harvest_date first, then fall back to packing_date
        let origin_date_str = null;
        if ((datasource.layer as any).harvest_date) {
            origin_date_str = (datasource.layer as any).harvest_date;
        } else if ((datasource.layer as any).packing_date) {
            origin_date_str = (datasource.layer as any).packing_date;
        }

        // Validate dates
        if (!origin_date_str) {
            return this;
        }

        // Calculate fruit_age (days from origin to current date)
        const origin_date = dayjs(origin_date_str);
        const current_date = dayjs();

        if (origin_date.isValid()) {
            this.value = current_date.diff(origin_date, "day");
        }

        return this;
    }

    display_component(): JSX.Element {
        if (!this.value) {
            return <span>-</span>;
        }
        // TODO: set opacity if last_date_in_facility is known
        if ((this.value as number) > 70) {
            return <span className="text-muted">&gt; 70 days</span>;
        }
        if ((this.value as number) > 36) {
            return <span className="text-danger">{this.value} days</span>;
        }
        if ((this.value as number) >= 21) {
            return <span className="text-warning">{this.value} days</span>;
        }
        return <span className="text-success">{this.value} days</span>;
    }

}

export default LayerFruitAgeField;
